import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

import CreateRecordButtonLayout from "../layout/CreateRecordButtonLayout";
import TkPopMaterialAcquisitionDialog from "../dialogTypes/TkPopMaterialAcquisitionDialog";
import getSpecific from "../../lib/api/getSpecific";

function TkPopMaterialAcquisitionButton(props) {

    const { t } = useTranslation();

    const { id, refresh, onSuccess, createButtonName, customizeErrorMsgCallback, onSelectMst, onTrigger, ...others } = props;

    const [open, setOpen] = useState(false);

    const [schema, setSchema] = useState();

    const [preProcessCode, setPreProcessCode] = useState();

    const [preCompanyCode, setPreCompanyCode] = useState();

    useEffect( () => {

        let schema = {

            name: "TkPopProductManage",
            type: "BASE TABLE",
            searchAll: false,
            formGroups: [
                "bobMaterialInfo",
                "acquireInfo",
            ],

            columns: [

                {

                    name: "workOrderNumber",
                    type: "varchar(45)",
                    nullable: "NO",
                    default: null,
                    disabled: true,
                    formGroup: 0,
                    formOrder: 10,
                    formItemType: "text",

                },
                {

                    name: "modelName",
                    type: "varchar(50)",
                    nullable: "NO",
                    default: null,
                    disabled: true,
                    formGroup: 0,
                    formOrder: 10,
                    formItemType: "text",

                },
                {

                    name: "modelPartName",
                    type: "varchar(50)",
                    nullable: "NO",
                    default: null,
                    disabled: true,
                    formGroup: 0,
                    formOrder: 10,
                    formItemType: "text",

                },
                {

                    name: "partNo",
                    type: "varchar(50)",
                    nullable: "NO",
                    default: null,
                    disabled: true,
                    formGroup: 0,
                    formOrder: 10,
                    formItemType: "text",

                },
                {

                    name: "partSeq",
                    type: "varchar(50)",
                    nullable: "NO",
                    default: null,
                    disabled: true,
                    formGroup: 0,
                    formOrder: 10,
                    formItemType: "text",

                },
                {

                    name: "preProcessCode",
                    type: "varchar(50)",
                    nullable: "NO",
                    formGroup: 1,
                    formOrder: 60,
                    formItemType: "autocomplete",
                    codeInfo: {
                        tableName: `TkVwPopProductManage`,
                        nameColumn: ["processName"],
                        valueColumn: "processCode",
                        seperator: ": ",
                        useEmptyValue: true,
                        emptyName: "term.none",
                        sortByName: true,
                    },

                },
                {

                    name: "preCompanyCode",
                    type: "varchar(200)",
                    nullable: "NO",
                    formGroup: 1,
                    formOrder: 70,
                    formItemType: "autocomplete",
                    codeInfo: {
                        tableName: "MomSysUdtCompany",
                        nameColumn: ["companyName"],
                        valueColumn: "companyCode",
                        seperator: ": ",
                        useEmptyValue: true,
                        emptyName: "term.none",
                        sortByName: true,
                    }

                },
                {

                    name: "consignee",
                    type: "varchar(255)",
                    nullable: "NO",
                    default: null,
                    required: true,
                    formGroup: 1,
                    formOrder: 80,
                    formItemType: "autocomplete",
                    codeInfo: {
                        tableName: "User",
                        nameColumn: ["fullName"],
                        valueColumn: "username",
                        seperator: ": ",
                        useEmptyValue: true,
                        emptyName: "term.none",
                        sortByName: true,
                    }

                },
                
            ]

        };

        setSchema(schema);

    }, []);

    useEffect(() => {

        if ( schema ) {
    
            let preProcessCode = schema?.columns.findIndex(v => v.name === "preProcessCode");

            schema.columns[preProcessCode].codeInfo.tableName = `TkVwPopProductManage/TkVwPopProcessByParentPlanId/${onSelectMst?.parentPlanId}`;

        }

    }, [schema, onSelectMst]);

    const onOpen = async () => {

        if ( onSelectMst ) {

            let processByParentPlan = await getSpecific("TkVwPopProductManageDetail/preProcess", onSelectMst.parentPlanId);

            setPreProcessCode(processByParentPlan?.data[0]?.processCode);

            let ownCompany = await getSpecific("MomSysVwOwnCompany");

            setPreCompanyCode(ownCompany?.data[0]?.companyCode);

        }

        setOpen(true);
        onTrigger(true)
    };

    const onClose = () => {

        setOpen(false);
        onTrigger(false)
    };

    const onCreateSuccess = (msg) => {

        if (onSuccess) {

            onSuccess(msg);

        }

    };

    const modifyUrlCallback = (url, id) => {

        if ( id === "ElectrodeProcessing" ) {

            return `${url}/${onSelectMst.planId}/acquisition?${id}`;

        }

        return `${url}/${onSelectMst.planId}/acquisition`;

    }

    return (

        <>
            <CreateRecordButtonLayout id={id + "create-button"} onClick={onOpen} createButtonName={createButtonName} {...others} />
            <TkPopMaterialAcquisitionDialog
                id={id + "create-dialog"}
                mode="create"
                formId={id + "create-form"}
                title={t(`dialog.title.Produce.acquisition`)}
                schema={schema}
                initialData={undefined}
                open={open}
                onClose={onClose}
                onSuccess={onCreateSuccess}
                customizeErrorMsgCallback={customizeErrorMsgCallback}
                modifyUrlCallback={(url) => modifyUrlCallback(url, id)}
                onSelectMst={onSelectMst}
                preProcessCode={preProcessCode}
                preCompanyCode={preCompanyCode}
                noKeepOpen={true}
            />
        </>

    );
}

export default TkPopMaterialAcquisitionButton;

